/* Version: 3.5.155 */
'use client';
var ALIGNMENT = {
  CENTER: 'center',
  END: 'flex-end',
  SPACE_AROUND: 'space-around',
  SPACE_BETWEEN: 'space-between',
  START: 'flex-start'
};
var DIRECTION = {
  COLUMN: 'column',
  ROW: 'row'
};
var KEY = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  TAB: 'Tab'
};
var KEY_CODE = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  TAB: 9
};
var SIDES = {
  TOP: 'top',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left',
  RIGHT: 'right'
};

export { ALIGNMENT, DIRECTION, KEY, KEY_CODE, SIDES };
